import React from 'react';
import './FormattedDate.css';

const FormattedDate = ({ date, format = 'DD/MM/YYYY' }) => {
  if (!date) return <span className="formatted-date">-</span>;

  const formatDate = (dateString, formatStr) => {
    let d;
    if (dateString.includes('T')) {
      d = new Date(dateString);
    } else {
      d = new Date(dateString + "T12:00:00");
    }
    if (isNaN(d.getTime())) return dateString;

    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    const shortYear = String(year).slice(-2);

    switch (formatStr) {
      case 'DD/MM/YYYY':
        return `${day}/${month}/${year}`;
      case 'YYYY/MM/DD':
        return `${year}/${month}/${day}`;
      case 'MM/YY':
        return `${month}/${shortYear}`;
      case 'relative':
        return getRelativeTime(d);
      default:
        return `${day}/${month}/${year}`;
    }
  };

  const getRelativeTime = (date) => {
    const now = new Date();
    const diff = now - date;
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 30) {
      return date.toLocaleDateString('es-ES');
    } else if (days > 0) {
      return `hace ${days} día${days > 1 ? 's' : ''}`;
    } else if (hours > 0) {
      return `hace ${hours} hora${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      return `hace ${minutes} minuto${minutes > 1 ? 's' : ''}`;
    } else {
      return 'hace un momento';
    }
  };

  const formatted = formatDate(date, format);

  return (
    <span className="formatted-date" data-format={format}>
      {formatted}
    </span>
  );
};

export default FormattedDate;
